import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import LaneChip from './LaneChip';
import { formatDateTime } from './historyFormatters';
import { tableSx, headSx, valueSx } from './historyTableStyles';

/**
 * StatusHistoryTable — Date & Time | Previous lane | New lane | Changed by.
 * Oldest first (from API). The last row's "New lane" is the current status,
 * highlighted. Null previous lane (package creation) shows an em-dash.
 */
function StatusHistoryTable({ rows = [] }) {
  if (!rows.length) {
    return <div className="phm-empty">No records found.</div>;
  }

  const lastIdx = rows.length - 1;

  return (
    <Table size="small" stickyHeader sx={tableSx}>
      <TableHead>
        <TableRow>
          <TableCell sx={headSx}>Date &amp; Time</TableCell>
          <TableCell sx={headSx}>Previous lane</TableCell>
          <TableCell sx={headSx}>New lane</TableCell>
          <TableCell sx={headSx}>Changed by</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((r, i) => (
          <TableRow key={r.id}>
            <TableCell sx={valueSx}>{formatDateTime(r.changedAt)}</TableCell>
            <TableCell>
              <LaneChip name={r.oldStatusName} />
            </TableCell>
            <TableCell>
              <LaneChip name={r.newStatusName} highlight={i === lastIdx} />
            </TableCell>
            <TableCell sx={valueSx}>{r.changedByName || '—'}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

export default StatusHistoryTable;
